"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./DropdownList.css");
var __exports_1 = require("../__exports");
var DropdownList = /** @class */ (function (_super) {
    __extends(DropdownList, _super);
    function DropdownList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.value
        };
        _this._onChange = _this._onChange.bind(_this);
        return _this;
    }
    DropdownList.prototype._onChange = function (event) {
        var value = event.target.value;
        this.setState({
            value: value
        });
        this.props.onChange && this.props.onChange(value);
    };
    DropdownList.prototype.componentWillReceiveProps = function (props) {
        if (this.props.value !== props.value) {
            this.setState({
                value: props.value
            });
        }
    };
    DropdownList.prototype.render = function () {
        var cssOuter = ['p-dropdownlist', 'form-row'];
        var _a = this
            .props, onRef = _a.onRef, id = _a.id, tag = _a.tag, label = _a.label, ariaLabelledBy = _a.ariaLabelledBy, name = _a.name, width = _a.width, showLabel = _a.showLabel, items = _a.items, isRequired = _a.isRequired, isEnabled = _a.isEnabled, errorMessage = _a.errorMessage;
        if (width) {
            cssOuter.push('width-' + width.toLowerCase());
        }
        if (isRequired) {
            cssOuter.push('is-required');
        }
        if (!isEnabled) {
            cssOuter.push('is-disabled');
        }
        if (errorMessage) {
            cssOuter.push('is-invalid');
        }
        var accessibilityAttr = {};
        // when the caption is hidden use the caption value as aria-label
        if (!showLabel) {
            accessibilityAttr['aria-label'] = label;
        }
        // caption and ariaLabelledBy are mutually exclusive. Caption will overwrite ariaLabelledBy
        if (ariaLabelledBy && !label) {
            accessibilityAttr['aria-labelledby'] = ariaLabelledBy;
        }
        if (isRequired) {
            accessibilityAttr['required'] = true;
        }
        var classes = ['default', 'p-bc-f-blue50', 'p-bg-hv-white'];
        if (errorMessage === '') {
            classes.push('p-bc-grey40');
        }
        else {
            classes.push('p-bc-error50');
        }
        return (React.createElement("div", { className: cssOuter.join(' ') },
            showLabel &&
                label && (React.createElement("label", { htmlFor: id },
                label,
                isRequired && React.createElement("span", { className: "p-t-error50" }, "*"))),
            React.createElement("div", { className: "p-dropdown-list-wrapper" },
                React.createElement("select", __assign({ id: id }, accessibilityAttr, { "data-tag": tag, name: name, value: this.state.value, onChange: this._onChange, disabled: !isEnabled, className: classes.join(' '), ref: onRef }), items.length &&
                    items.map(function (item) { return (React.createElement("option", { key: item.value, value: item.value }, item.label)); })),
                React.createElement("span", { className: "p-icon-down-triangle", "aria-hidden": true })),
            errorMessage && React.createElement("p", { className: "error p-t-error50" }, errorMessage)));
    };
    DropdownList.defaultProps = {
        id: 'idp' + __exports_1.default.createUUID(),
        tag: null,
        label: null,
        ariaLabelledBy: null,
        name: null,
        width: 'Block',
        value: '',
        showLabel: true,
        items: [],
        isRequired: false,
        isEnabled: true,
        errorMessage: ''
    };
    return DropdownList;
}(React.Component));
exports.DropdownList = DropdownList;
exports.default = DropdownList;
//# sourceMappingURL=DropdownList.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/dropdown-list/build/control/DropdownList.js
// module id = 269
// module chunks = 0